import { MdInfoOutline } from 'react-icons/md';
import CollectionAgreementCard from './CollectionAgreementCard';
import type useOperationCollectionAgreement from '../useOperationCollectionAgreement';
import type { CollectionAgreement } from '../collectionAgreementModel';

interface OperationCollectionAgreementSectionProps {
    agreement: ReturnType<typeof useOperationCollectionAgreement>;
    onChange: (agreement: CollectionAgreement) => void;
}

const OperationCollectionAgreementSection = ({ agreement, onChange }: OperationCollectionAgreementSectionProps) => {
    const { draft, setDraft, policies, fieldErrors, failed } = agreement;
    if (!draft) return null;
    const change = (next: CollectionAgreement) => { setDraft(next); onChange(next); };
    const notice = (failed || !draft.id) && (
        <p className="flex items-center gap-2 rounded-lg bg-amber-50 px-4 py-2 text-sm text-amber-800 dark:bg-amber-900/30 dark:text-amber-200">
            <MdInfoOutline size={16} />
            {failed
                ? 'O acordo de cobrança não foi salvo. Corrija os campos destacados e salve de novo.'
                : 'Esta operação ainda não tem acordo de cobrança: ele é criado ao salvar.'}
        </p>
    );

    return (
        <div className="mt-4 mb-6">
            <CollectionAgreementCard agreement={draft} policies={policies} fieldErrors={fieldErrors}
                notice={notice} onChange={change} />
        </div>
    );
};

export default OperationCollectionAgreementSection;
